module.exports = __webpack_public_path__ + "img/45-puck.9ce979b5.png";